<script>
	import confirmationPages from "../confirmationPages";
	import { projectSettings } from "../../config";

	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ReviewSectionHeader from "../../components/ReviewSectionHeader.svelte";

	let disabled = true;

	document.title = `${projectSettings.classActionName} - Review`;
</script>

<section>
	<FormRow class="justify-content-center">
		<FormColumn>
			<h1 class="text-center">{@html projectSettings.classActionName}</h1>
		</FormColumn>
	</FormRow>

	<div class="confirmation">
		{#each confirmationPages as page}
			<ReviewSectionHeader heading={page.confirmationHeading}></ReviewSectionHeader>

			<svelte:component this={page.component} {...page} {disabled} />
		{/each}
		<FormRow>
			<p>
				By registering with us, you are signing up to receive updates on our investigation into a potential
				class action regarding talc-based powders manufactured/supplied by Johnson & Johnson and their alleged
				link to ovarian cancer and other cancers of the female reproductive system. Registering with us does not
				establish a solicitor client legal relationship with Shine Lawyers. No court proceedings have been filed
				and we may ultimately after investigations have concluded decide not to proceed with the case. As we
				have not entered into a solicitor client retainer with you at this time any rights you may have are not
				presently protected.  Statutory time limits may also apply to your claim. If you have any concerns about
				your potential claim, please seek independent legal advice immediately.
			</p>
		</FormRow>
	</div>
</section>
